export enum STATUS {
  DRAFT = 'Concept',
  NEW_PROJECT = 'Nieuw',
  COMPLETE = 'Uitgevoerd',
  INVOICE = 'Te_factureren',
  PARTIAL_INVOICE = 'Deels_factureren',
  DESIGN = 'Ontwerp',
  IN_PROGRESS = 'In_behandeling',
  REJECTED_QUOTATION = 'Afgekeurd',
  ARCHIVED = 'Gearchiveerd',
  NOT_EXECUTED = 'Niet_uitgevoerd',
  DELAYED = 'Uitgesteld'
}
